// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1zUtL","content":"styles_content__2YnER","selectAll":"styles_selectAll__o_nWg"};